module.exports = __webpack_public_path__ + "static/media/IMG_4371.7d34479c.jpg";